/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Form,
  Modal,
  Typography,
  Row,
  Grid,
  Button,
  Col,
  Spin,
} from 'antd';

import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import { onError } from 'utils/handlers';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import Select from 'components/Select';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';

const { Text } = Typography;

const ModalPeriodoPagoLiquidacionEmpleado = ({
  onUnasign,
  onCancel,
  open,
  loading,
  form,
  rules,
}) => {
  const screens = Grid.useBreakpoint();
  const nameTiposEmpleado = 'tipo_empleado';
  const namePeriodoFiscal = 'periodo_fiscal';
  const tiposEmpleadoWatcher = Form.useWatch(nameTiposEmpleado, form);
  const periodoFiscalWatcher = Form.useWatch(namePeriodoFiscal, form);

  const [periodosDeNominaDetallesFiltered, setPeriodosDeNominaDetallesFiltered] = useState([]);
  const [periodosDeNominaDetalles, setPeriodosDeNominaDetalles] = useState([]);
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  const [periodosDeNominasFiltered, setPeriodosDeNominasFiltered] = useState([]);
  const [periodosDeNominas, setPeriodosDeNominas] = useState([]);
  const [tiposDeNominas, setTiposDeNominas] = useState([]);
  const [loadingInner, setLoadingInner] = useState(false);
  useEffect(() => {
    const _periodosDetallesFiltered = periodosDeNominaDetalles?.filter(
      (periodo) => (
        (periodo.periodo_de_nomina === tiposEmpleadoWatcher)),
    );
    setPeriodosDeNominaDetallesFiltered(_periodosDetallesFiltered);
  }, [tiposEmpleadoWatcher]);
  useEffect(() => {
    const _periodosFiltered = periodosDeNominas?.filter(
      (periodo) => (
        (periodo.periodo_fiscal === periodoFiscalWatcher)),
    );
    setPeriodosDeNominasFiltered(_periodosFiltered);
  }, [periodoFiscalWatcher]);

  useEffect(() => {
    const loadCatalogs = async () => {
      try {
        setLoadingInner(true);
        const [
          _periodosFiscales,
          _periodosDeNominaDetalles,
          _periodosNominas,
          _tipos_de_nominas_empleados,
        ] = await Promise.all([
          getPeriodosFiscales({ estados_globales: ESTATUS_AUTORIZADO }),
          getPeriodosDeNominasDetalles(),
          getPeriodosDeNominas(),
          getTiposDeNominasEmpleados(),
        ]);
        setPeriodosDeNominas(
          _periodosNominas?.filter((p) => p.estados_globales === ESTATUS_AUTORIZADO),
        );
        setPeriodosDeNominaDetalles(
          _periodosDeNominaDetalles?.filter(
            (p) => _periodosNominas.some((n) => n.id === p?.periodo_de_nomina),
          ),
        );
        setPeriodosFiscales(_periodosFiscales);
        setTiposDeNominas(_tipos_de_nominas_empleados);
      } catch (err) {
        onError(err);
      } finally {
        setLoadingInner(false);
      }
    };
    loadCatalogs();
  }, []);
  return (
    <Spin tip="Cargando..." spinning={loadingInner}>
      <Modal
        title={(
          <Row justify="space-between">
            <Text>
              Desasignar Plaza
            </Text>
            <Row className="form-submit-controls">
              <Button
                type="link"
                onClick={onCancel}
                disabled={loading}
              >
                <ArrowLeftOutlined />
                {screens.md && 'Cancelar'}
              </Button>
              <Button
                type="link"
                onClick={onUnasign}
                disabled={loading}
                style={{ marginLeft: 10 }}
                className="submit-delete"
                autoFocus
              >
                <SaveOutlined />
                {screens.md && 'Guardar'}
              </Button>
            </Row>
          </Row>
        )}
        className="modal-delete"
        open={open}
        footer={null}
        closable={false}
        maskClosable={!loading}
        keyboard={!loading}
        destroyOnClose
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={() => onUnasign()}
          scrollToFirstError
        >
          <Col xs={24} sm={24} md={24}>
            <Form.Item
              name={namePeriodoFiscal}
              label="Periodo Fiscal"
              rules={rules.required}
              hasFeedback
            >
              <Select
                dataSource={periodosFiscales}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24}>
            <Form.Item
              name={nameTiposEmpleado}
              label="Tipo de Empleado"
              rules={rules.required}
            >
              <Select
                render={(value) => tiposDeNominas?.find(
                  (nomina) => nomina.id === value?.tipo_de_nomina_empleado,
                )?.descripcion}
                dataSource={periodosDeNominasFiltered}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24}>
            <Form.Item
              name="periodo_de_nomina_detalle"
              label="Periodo de Nómina"
              rules={rules.required}
              hasFeedback
            >
              <Select
                dataSource={periodosDeNominaDetallesFiltered}
                render={(value) => `${value?.numero_de_nomina} (${value?.fecha_inicial} al ${value?.fecha_final})`}
              />
            </Form.Item>
          </Col>
        </Form>
      </Modal>
    </Spin>
  );
};

export default ModalPeriodoPagoLiquidacionEmpleado;
